var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "painel-card-vivo az-gap-xsmall" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex align-center flex-wrap az-gap-small painel-card-vivo__cabecalho"
      },
      [
        _c(
          "span",
          {
            staticClass: "painel-avatar flex-shrink-0",
            class: _vm.avatarFalando
              ? "painel-avatar--falando"
              : "painel-avatar--pronto",
            attrs: { "aria-hidden": "true" }
          },
          [
            _c("icon-svg", {
              attrs: {
                name: _vm.card.icone,
                size: 14,
                color: _vm.corDoIconeDoAvatar
              }
            })
          ],
          1
        ),
        _c("span", { staticClass: "az-text-primary az-size-12 font-medium" }, [
          _vm._v(_vm._s(_vm.card.label))
        ]),
        _vm.card.indisponivel
          ? _c("BaseStatus", {
              attrs: {
                soft: "",
                "preserve-case": "",
                content: _vm.card.texto,
                color: "warning-new"
              }
            })
          : _vm._e(),
        _vm.textoDeEstado
          ? _c(
              "output",
              {
                staticClass: "az-text-secondary az-size-12 az-muted",
                class: _vm.mostraEspera ? _vm.classeShimmer : "",
                attrs: { "aria-live": "polite" }
              },
              [_vm._v(" " + _vm._s(_vm.textoDeEstado) + " ")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm.card.fala
      ? _c(
          "div",
          {
            staticClass: "az-text-secondary az-size-12 painel-card-vivo__fala",
            attrs: { "aria-live": "off" }
          },
          [
            _vm._v(" " + _vm._s(_vm.card.fala)),
            _vm.mostraSpinnerDaFala
              ? _c("span", {
                  staticClass: "iv2-cursor-digitando",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm.card.motivo
      ? _c(
          "div",
          {
            staticClass:
              "az-text-secondary az-size-12 az-muted painel-card-vivo__linha"
          },
          [_vm._v(" " + _vm._s(_vm.card.motivo) + " ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }